<template>
  <esg-base-dashboard-card title="온실가스 배출량 추이 "
                           :subtitle="`(법인 A~D - ${currentYear}년 월별)`">
    <template #actions>
      <esg-base-select-box label="법인"
                           v-model="corporationCode"
                           :options="corporations"/>
    </template>
    <corp-monthly-emission-by-scope v-show="corporationCode"
                                    :corporation="corporation"
                                    @dataPointSelection="onDataPointSelection"/>
    <b class="annotation">사업장별 세부정보를 보시려면 그래프를 클릭해주세요</b>

    <!-- 사업장별 월별 온실가스 배출량 -->
    <esg-base-dashboard-modal id="esg-by-org-2"
                              size="lg">
      <all-biz-loc-emission-by-month :corporation="selectedCorporation"/>
    </esg-base-dashboard-modal>
    <!-- /사업장별 월별 온실가스 배출량 -->
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import CorpMonthlyEmissionByScope
  from "@/components/esg/3. Monitoring/charts2/CorpEmissionByMonth.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";
import AllBizLocEmissionByMonth from "@/components/esg/3. Monitoring/dashboardCards/AllBizLocEmissionByMonth.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";

export default {
  name: "SelectableCorpMonthlyEmissionByScope",
  components: {
    EsgBaseDashboardModal,
    AllBizLocEmissionByMonth, EsgBaseSelectBox, CorpMonthlyEmissionByScope, EsgBaseDashboardCard
  },
  data() {
    return {
      corporationCode: '',
      corporations: [],
      selectedCorporation: {}
    }
  },
  computed: {
    corporation() {
      if (!this.corporationCode)
        return {}
      return this.corporations.find(corp => corp.code === this.corporationCode);
    }
  },
  created() {
    this.fetchCorps();
  },
  methods: {
    async fetchCorps() {
      try {
        let response = await axios.get('esg/lca/tables/esg_base_corporation', {
          headers: {Authorization: accessToken()},
        });

        // Add value and text to use data as select options
        response.data.list.forEach(corp => {
          corp.value = corp.code;
          corp.text = corp.name;
        });

        this.corporations = response.data.list;

        // Set default
        this.corporationCode = this.corporations[0].code;
      } catch (error) {
        await this.showError(error);
      }
    },
    onDataPointSelection(corporation) {
      this.selectedCorporation = corporation;
      this.$bvModal.show('esg-by-org-2');
    }
  }
}
</script>

<style scoped>
.annotation {
  font-size: 10px;
  font-weight: 500;
  font-family: NanumGothic;
  color: #888;
}
</style>